var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i-select',{attrs:{"value":_vm.id,"filterable":true},on:{"input":_vm.input}},_vm._l((_vm.list),function(item,key){return _c('i-option',{key:key,attrs:{"label":item.name,"value":item.value}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }